import { api } from "@/api";
import { CountryWithLeagues } from "@/types/ApiResponses/Country";
import { QueryProps } from "@/types/Api";

export interface GetCountriesLeaguesParams {
  lang?: string;
  code?: string;
  slug?: string;
  sportId?: number;
  // Public-nav opt-in: backend returns only leagues that currently have
  // matches. Omitted by admin league management (keeps the full list).
  onlyWithMatches?: boolean;
}

export const getLeaguesGroupedByCountry = async (
  props: QueryProps<GetCountriesLeaguesParams>
): Promise<CountryWithLeagues[]> => {
  const res = await api.client.get("/countries-new/with-leagues", {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
